import { render, staticRenderFns } from "./ParentingAfterSeparation.vue?vue&type=template&id=7b867bc2&scoped=true"
import script from "./ParentingAfterSeparation.vue?vue&type=script&lang=ts"
export * from "./ParentingAfterSeparation.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=7b867bc2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b867bc2",
  null
  
)

export default component.exports